const keepOnlyNumbers = text => {
  return text.replace(/\D/g, '')
}

const removeBlankSpaces = text => {
  return text.replace(/\s/g, '')
}

export default { keepOnlyNumbers, removeBlankSpaces }
